import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    addNewRowToTable,
    convertUniversalDateTimeToPersianDateTime, DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoSimpleInputOutlined,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {ProductService} from "../../serverService/productService/ProductService";
import {useDebounce} from "@uidotdev/usehooks";
import AddNewProduct from "./addNewProduct/AddNewProduct";
import {useNavigate} from "react-router-dom";

export default function Products() {

    const size = 20;
    let page = 0;

    const [totalItems, setTotalItems] = useState(0);
    const [productListData, setProductListData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);

    const [titleFilter, setTitleFilter] = useState("");
    const [slugFilter, setSlugFilter] = useState("");

    const _titleFilter = useDebounce(titleFilter, 500);
    const _slugFilter = useDebounce(slugFilter, 500);

    const service = new ProductService();

    useEffect(() => {
        if (typeof service !== "undefined") {
            getProductListFromServer()
        }
    }, [_titleFilter, _slugFilter]);

    function tablePreparation(number, id, title, slug, createdBy, createdAt, updatedAt, updatedBy) {
        return {
            number,
            id,
            title,
            slug,
            createdBy,
            createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
            updatedAt: convertUniversalDateTimeToPersianDateTime(updatedAt),
            updatedBy: updatedBy
        }
    }

    function getProductListFromServer() {
        setTableLoading(true)
        service.getProductList(
            page,
            size,
            _titleFilter,
            _slugFilter
        ).then(response => {
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)

            setProductListData([])
            response.data.map((item, index) => {
                setProductListData(prevState => [
                    ...prevState,
                    tablePreparation(
                        (page * size) + index + 1,
                        item.id,
                        item.title,
                        item.slug,
                        item.createdBy,
                        item.createdAt,
                        item.updatedAt,
                        item.updatedBy
                    )
                ])
            })
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoading(false)
        })

    }

    function handleChangePage(newPage) {
        page = newPage;
        getProductListFromServer()
    }

    const [productDialogState, setProductDialogState] = useState(false)

    function handleOpenProductDialog() {
        setProductDialogState(true)
    }

    function handleCloseProductDialog() {
        setProductDialogState(false)
    }

    function addNewProductToTable(item) {
        const _items = addNewRowToTable(
            tablePreparation(
                1,
                item.id,
                item.title,
                item.slug,
                item.createdBy,
                item.createdAt,
                item.updatedAt,
                item.updatedBy
            ),
            productListData
        );
        setProductListData(_items)
    }

    const navigate = useNavigate()

    function handleShowProductDetails(productId) {
        let _title = ""
        productListData.map((item) => {
            if (item.id === productId)
                _title = item.title
        })
        navigate(RouteHelper.ProductDetails.globalUrl.replace(":id", productId),
            {state: {title: _title}, replace: false}
        )
    }

    function handleDeleteAllFilters() {
        setSlugFilter("")
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.Products.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseProductDialog}
                open={productDialogState}
                dialogSize={DialogSize.WRAP_CONTENT}
                hasCloseButton={false}
            >
                <AddNewProduct
                    handleCloseProductDialog={handleCloseProductDialog}
                    handleAddNewProduct={addNewProductToTable}
                />
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Store.name,
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Products.name,
                                ""
                            )
                        ]}
                    />
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={RouteHelper.Products.name}
                                amount={totalItems}
                                hasCreateNewItem
                                handleCreateNewItem={handleOpenProductDialog}
                            />
                            <RaikoTableSearchContainer
                                value={titleFilter}
                                setValue={setTitleFilter}
                                labelText={"عنوان"}
                                hasSearchInput
                                placeHolder={"نام محصول مورد نظر را وارد نمایید."}
                                hasFilter
                                handleDeleteAllFilters={handleDeleteAllFilters}
                                filterStatus={
                                    slugFilter.length > 0
                                }
                            >
                                <RaikoSimpleInputOutlined
                                    labelText={"slug"}
                                    value={slugFilter}
                                    setValue={setSlugFilter}
                                />
                            </RaikoTableSearchContainer>
                            <RaikoCustomTable
                                header={productTableHeader}
                                data={productListData}
                                isLoading={tableLoading}
                                pageCount={pageCount}
                                handlePaginationChange={handleChangePage}
                                rowClicked={handleShowProductDetails}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}
const productTableHeader = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "title",
        label: "عنوان"
    },
    {
        id: "slug",
        label: "slug"
    },
    {
        id: "createdBy",
        label: "سازنده"
    },

    {
        id: "createdAt",
        label: "تاریخ ساخت"
    },
    {
        id: "updatedAt",
        label: "بروزرسانی"
    },
    {
        id: "updatedBy",
        label: "بروزرسانی شده"
    },
]